export default "__VITE_ASSET__CRCUzkC___"